
import { css } from 'lit';
export default css`
pc-pager{
  display:block;
}

  pc-pager .pager{
    padding-top:var(--spacing-4);
    padding-bottom:var(--spacing-4);
  }

  pc-pager .visually-hidden{
    display:none;
  }

  pc-pager .pager__items{
    display:flex;
    justify-content:center;
    align-items:center;
    gap:var(--spacing-6);
  }

  pc-pager .pager__item:not(.is-active):not(.pager__item--previous):not(
      .pager__item--next
    )
    pc-link{
    --link-color:var(--neutral-medium-gray);
  }

  pc-pager .pager__item.is-active pc-link{
    --link-lg-font-weight:var(--fw-medium);
  }

  pc-pager .pager__item--previous{
    margin-right:var(--spacing-6);
  }

  pc-pager .pager__item--next{
    margin-left:var(--spacing-6);
  }

  pc-pager .pager__directional{
    display:flex;
    column-gap:var(--spacing-2);
    align-items:center;
  }

  @media (max-width: 767px){
    pc-pager .pager__item--previous span,
    pc-pager .pager__item--next span{
      display:none;
    }
  }
`;